import React, { ReactElement } from 'react';

import { MessageBlock } from 'elmo-elements';

import AddReviewerButton from '../AddReviewerButton';

const NoReviewersMessage = (): ReactElement => (
  <>
    <br />
    <br />
    <br />
    <br />
    <MessageBlock>
      <MessageBlock.Header>
        Proofread this module before publishing
      </MessageBlock.Header>
      <MessageBlock.Body>
        To add a reviewer please click the button below
        <br />
        <br />
        <AddReviewerButton />
      </MessageBlock.Body>
    </MessageBlock>
  </>
);

export default NoReviewersMessage;
